import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "p", "br", "div", "span", "strong", "b", "em", "i", "u", "s", "strike",
  "sub", "sup", "h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "ul",
  "ol", "li", "table", "thead", "tbody", "tfoot", "tr", "th", "td",
  "font", "a", "img",
];

const ALLOWED_ATTR = [
  "style", "align", "href", "title", "target", "rel", "color", "face", "size",
  "width", "height", "border", "cellpadding", "cellspacing", "colspan", "rowspan",
  "start", "type", "value", "src", "alt", "data-document-image-id",
];

const ALLOWED_STYLE_PROPERTIES = new Set([
  "color", "background-color", "font-family", "font-size", "font-weight",
  "font-style", "text-decoration", "text-align", "line-height", "white-space",
  "vertical-align", "margin", "margin-top", "margin-right", "margin-bottom",
  "margin-left", "padding", "padding-top", "padding-right", "padding-bottom",
  "padding-left", "border", "border-top", "border-right", "border-bottom",
  "border-left", "border-width", "border-style", "border-color", "border-radius",
  "border-collapse", "width", "min-width", "max-width", "height", "min-height",
  "max-height", "list-style-type", "display", "object-fit",
]);

const isSafeCssValue = (value) =>
  value.length <= 160 &&
  !/(?:url\s*\(|expression\s*\(|javascript\s*:|data\s*:|@import|behavior\s*:|-moz-binding|[{}<>])/i.test(value);

const sanitizeStyles = (html) => {
  const template = document.createElement("template");
  template.innerHTML = html;
  template.content.querySelectorAll("[style]").forEach((element) => {
    const safe = [];
    for (let index = 0; index < element.style.length; index += 1) {
      const property = element.style.item(index).toLowerCase();
      const value = element.style.getPropertyValue(property).trim();
      const tagName = String(element.tagName || "").toLowerCase();
      const isTableElement = ["table", "td", "th"].includes(tagName);
      const borderStyle = property === "border" || (
        property.startsWith("border-") && property !== "border-radius"
      );
      if (
        ALLOWED_STYLE_PROPERTIES.has(property) &&
        (!borderStyle || isTableElement) &&
        isSafeCssValue(value)
      ) {
        safe.push(`${property}:${value}`);
      }
    }
    if (safe.length) {
      element.setAttribute("style", safe.join(";"));
    } else {
      element.removeAttribute("style");
    }
  });
  template.content.querySelectorAll("img").forEach((image) => {
    const src = String(image.getAttribute("src") || "").trim();
    if (!/^data:image\/(?:png|jpe?g|webp|gif);base64,[a-z0-9+/=\s]+$/i.test(src)) {
      image.remove();
      return;
    }
    if (!image.getAttribute("alt")) image.setAttribute("alt", "Imagem do documento");
  });
  template.content.querySelectorAll('a[target="_blank"]').forEach((link) => {
    link.setAttribute("rel", "noopener noreferrer");
  });
  return template.innerHTML.trim();
};

export const sanitizeDocumentTemplateHtml = (value) => {
  const sanitized = DOMPurify.sanitize(
    typeof value === "string" ? value : "",
    {
      ALLOWED_TAGS,
      ALLOWED_ATTR,
      ALLOW_DATA_ATTR: false,
      ALLOW_ARIA_ATTR: false,
      FORBID_TAGS: [
        "script", "style", "iframe", "object", "embed", "form", "input",
        "button", "link", "meta", "base", "svg", "math", "video",
        "audio", "source",
      ],
    },
  );
  return sanitizeStyles(sanitized);
};

export const DOCUMENT_TEMPLATE_HTML_ALLOWED_TAGS = [...ALLOWED_TAGS];
